"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_router_1 = require("react-router");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const cosmos_1 = require("components/cosmos");
const groupedSelect_1 = __importDefault(require("components/cosmos/select/groupedSelect"));
const Html_1 = __importDefault(require("components/Html"));
const xIconCloseButton_1 = require("components/xIconCloseButton");
const translationContext_1 = require("configs/translationContext");
const mobx_react_1 = require("mobx-react");
const useDrippingByQuizAlerts_1 = __importDefault(require("../hooks/useDrippingByQuizAlerts"));
const useQuizzesByModule_1 = __importDefault(require("../hooks/useQuizzesByModule"));
const stores_1 = require("../stores");
const mapStateToProps = (stores) => ({
    quizId: stores.DrippingFormStore.quizId,
    impactedModuleId: stores.DrippingStore.impactedModuleId
});
const DrippingByQuiz = ({ quizId, impactedModuleId }) => {
    const { t } = (0, translationContext_1.useTranslation)();
    const { id: currentPageId } = (0, react_router_1.useParams)();
    const { quizzesById, options, isLoading } = (0, useQuizzesByModule_1.default)(impactedModuleId, currentPageId);
    const quiz = quizId ? quizzesById[quizId] : null;
    const { alertConfigs, dismissAlert } = (0, useDrippingByQuizAlerts_1.default)(quiz);
    (0, react_1.useEffect)(() => {
        Object.values(quizzesById).forEach((quiz) => {
            stores_1.DrippingFormStore.addQuizDetails(quiz.id, {
                name: quiz.name
            });
        });
    }, [quizzesById]);
    if (isLoading) {
        return (0, jsx_runtime_1.jsx)(cosmos_1.ContentLoader, { className: "_mt-4", width: "100%", height: 100 });
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: "_bg-gray-100 _rounded _mt-4 _p-4", children: [options.length === 0 ? ((0, jsx_runtime_1.jsxs)("div", { className: "_d-flex _justify-content-center _gap-3 _text-gray-500", children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: ['fal', 'message-question'], className: "_text-3" }), t('dripping_2.new.release_and_expiration.release.items.quiz.empty_state')] })) : ((0, jsx_runtime_1.jsx)(groupedSelect_1.default, { options: options, label: t('general.quiz'), placeholder: t('dripping_2.new.release_and_expiration.release.items.quiz.placeholder'), id: "quiz", onChange: (option) => stores_1.DrippingFormStore.setQuizId((option === null || option === void 0 ? void 0 : option.value) || null), value: quizId || '' })), alertConfigs.length > 0 && ((0, jsx_runtime_1.jsx)("div", { className: "_d-flex _flex-column _gap-4 _mt-4", children: alertConfigs.map((alertConfig) => ((0, jsx_runtime_1.jsx)(cosmos_1.Alert, { type: alertConfig.type, className: "_m-0", children: (0, jsx_runtime_1.jsxs)("div", { className: "_d-flex _gap-4", children: [(0, jsx_runtime_1.jsxs)("div", { className: "_d-flex _align-items-center _gap-4", children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: ['fal', alertConfig.icon], className: "_text-4" }), (0, jsx_runtime_1.jsx)(Html_1.default, { children: t(alertConfig.text) })] }), (0, jsx_runtime_1.jsx)(xIconCloseButton_1.XIconCloseButton, { onClick: () => dismissAlert(alertConfig.name) })] }) }, alertConfig.text))) }))] }));
};
exports.default = (0, mobx_react_1.inject)(mapStateToProps)(DrippingByQuiz);
